import React from "react";
import { twMerge } from "tailwind-merge";

interface ProcessorIconProps {
  width?: number;
  height?: number;
  className?: string;
}

export const ProcessorIcon: React.FC<ProcessorIconProps> = ({
  width = 40,
  height = 48,
  className = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 40 42"
      fill="none"
      className={twMerge(className, "text-primary-foreground")}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_di_2184_4836)">
        <path
          d="M0 6C0 2.68629 2.68629 0 6 0L24 0L32 8V34C32 37.3137 29.3137 40 26 40H6C2.68629 40 0 37.3137 0 34V6Z"
          fill="currentColor"
        />
        <path
          d="M6 0.75H23.6895L31.25 8.31055V34C31.25 36.8995 28.8995 39.25 26 39.25H6C3.10051 39.25 0.75 36.8995 0.75 34V6C0.75 3.10051 3.10051 0.75 6 0.75Z"
          stroke="#3292ED"
          strokeWidth="1.5"
        />
      </g>
      <path d="M23 0L32 9H27C24.7909 9 23 7.20914 23 5V0Z" fill="#3292ED" />
      <path
        d="M16 12.584C17.7149 12.584 19.2986 12.8144 20.4795 13.208C21.0661 13.4035 21.5956 13.6535 21.9932 13.9668C22.3821 14.2734 22.75 14.7298 22.75 15.334C22.75 15.9382 22.3821 16.3945 21.9932 16.7012C21.5956 17.0145 21.0661 17.2644 20.4795 17.46C19.2986 17.8535 17.7149 18.084 16 18.084C14.2851 18.084 12.7014 17.8535 11.5205 17.46C10.9339 17.2644 10.4044 17.0145 10.0068 16.7012C9.61791 16.3945 9.25 15.9382 9.25 15.334C9.25 14.7298 9.61791 14.2734 10.0068 13.9668C10.4044 13.6535 10.9339 13.4035 11.5205 13.208C12.7014 12.8144 14.2851 12.584 16 12.584ZM16 14.084C14.4013 14.084 12.9847 14.3007 11.9941 14.6309C11.495 14.7972 11.1452 14.9793 10.9355 15.1445C10.813 15.2412 10.7694 15.3055 10.7549 15.334C10.7694 15.3625 10.813 15.4268 10.9355 15.5234C11.1452 15.6887 11.495 15.8707 11.9941 16.0371C12.9847 16.3673 14.4013 16.584 16 16.584C17.5987 16.584 19.0153 16.3673 20.0059 16.0371C20.505 15.8707 20.8548 15.6887 21.0645 15.5234C21.1865 15.4273 21.2294 15.3627 21.2441 15.334C21.2294 15.3053 21.1865 15.2407 21.0645 15.1445C20.8548 14.9793 20.505 14.7972 20.0059 14.6309C19.0153 14.3007 17.5987 14.084 16 14.084Z"
        fill="#3292ED"
      />
      <path
        d="M9.25 15.334C9.25 14.9198 9.58579 14.584 10 14.584C10.4142 14.584 10.75 14.9198 10.75 15.334V24.6523C10.7562 24.6693 10.7881 24.737 10.9268 24.8486C11.1302 25.0123 11.478 25.1981 11.9941 25.3701C13.0218 25.7127 14.4636 25.917 16 25.917C17.5364 25.917 18.9782 25.7127 20.0059 25.3701C20.522 25.1981 20.8698 25.0123 21.0732 24.8486C21.2119 24.737 21.2438 24.6693 21.25 24.6523V15.334C21.25 14.9198 21.5858 14.584 22 14.584C22.4142 14.584 22.75 14.9198 22.75 15.334V24.667C22.75 25.2526 22.4005 25.7052 22.0137 26.0166C21.6198 26.3336 21.0884 26.59 20.4795 26.793C19.2567 27.2005 17.6461 27.417 16 27.417C14.3539 27.417 12.7433 27.2005 11.5205 26.793C10.9116 26.59 10.3802 26.3336 9.98633 26.0166C9.59947 25.7052 9.25 25.2526 9.25 24.667V15.334Z"
        fill="#3292ED"
      />
      <path
        d="M22 19.25C22.4142 19.25 22.75 19.5858 22.75 20C22.75 20.5857 22.4006 21.0382 22.0137 21.3496C21.6198 21.6666 21.0884 21.923 20.4795 22.126C19.2568 22.5335 17.646 22.75 16 22.75C14.354 22.75 12.7432 22.5335 11.5205 22.126C10.9116 21.923 10.3802 21.6666 9.98633 21.3496C9.59941 21.0382 9.25 20.5857 9.25 20C9.25 19.5858 9.58579 19.25 10 19.25C10.409 19.25 10.7407 19.5774 10.749 19.9844C10.7544 19.9998 10.7858 20.0671 10.9268 20.1807C11.1302 20.3444 11.478 20.531 11.9941 20.7031C13.0218 21.0457 14.4636 21.25 16 21.25C17.5364 21.25 18.9782 21.0457 20.0059 20.7031C20.522 20.531 20.8698 20.3444 21.0732 20.1807C21.2133 20.0679 21.2444 20.0003 21.25 19.9844C21.2583 19.5774 21.591 19.25 22 19.25Z"
        fill="#3292ED"
      />
      <defs>
        <filter
          id="filter0_di_2184_4836"
          x="-4"
          y="-1"
          width="40"
          height="49"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="4"
            operator="erode"
            in="SourceAlpha"
            result="effect1_dropShadow_2184_4836"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="4" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
          />
          <feBlend
            mode="multiply"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2184_4836"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2184_4836"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-1" />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
          />
          <feBlend
            mode="multiply"
            in2="shape"
            result="effect2_innerShadow_2184_4836"
          />
        </filter>
      </defs>
    </svg>
  );
};
